export const videoTypes = {
  MOVIE_THEATRICAL: 'movie-theatrical',
  TELEVISION: 'television',
  MADE_FOR_VIDEO: 'made-for-video',
  VIDEO_COURSE: 'video-course',
  PORTFOLIO: 'portfolio',
  PERSONAL: 'personal',
  FILM: 'film',
  VLOG: 'vlog',
  WEB_SERIES: 'web-series',
  PRODUCT_DEMO: 'product-demo',
  TESTIMONIALS: 'testimonials',
  TUTORIALS: 'tutorials',
  EDUCATION: 'education',
  MUSIC: 'music',
  OTHER: 'other',
};


export default [
  videoTypes.MOVIE_THEATRICAL,
  videoTypes.TELEVISION,
  videoTypes.MADE_FOR_VIDEO,
  videoTypes.VIDEO_COURSE,
  videoTypes.PORTFOLIO,
  videoTypes.PERSONAL,
  videoTypes.FILM,
  videoTypes.VLOG,
  videoTypes.WEB_SERIES,
  videoTypes.PRODUCT_DEMO,
  videoTypes.TESTIMONIALS,
  videoTypes.TUTORIALS,
  videoTypes.EDUCATION,
  videoTypes.MUSIC,
  videoTypes.OTHER,
];



// WEBPACK FOOTER //
// ./src/shared/constants/video-types.js